import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './HighlightedArticle.module.sass';
import dateToMonthAndYear from '../../../services/date_service';
import Button from '../../../../ui_kit/button/Button';

class HighlightedArticle extends Component {
  componentDidMount() {
    window.lazyLoad.update();
  }

  render() {
    const { article, className } = this.props;
    const {
      title, media_name: mediaName, link, background_image: { url: image },
    } = article;
    const publishedAt = dateToMonthAndYear(new Date(article.published_at));

    return (
      <div className={`${styles.article} ${className}`}>
        <div className={styles.content}>
          { image && (
          <div className={styles.image}>
            <img className="lazyload" data-src={image} alt="" />
          </div>
          )}
          <div className={styles.text}>
            <div className={styles['media-name']}>
              {mediaName}
            </div>
            <div className={styles.date}>
              {publishedAt}
            </div>
            <div className={styles.title}>
              {title}
            </div>
            <Button
              className={styles.button}
              size="small"
              color="transparent-blue"
              text="READ ARTICLE"
              href={link}
              target="_blank"
            />
          </div>
        </div>
      </div>
    );
  }
}

HighlightedArticle.propTypes = {
  article: PropTypes.shape({
    media_name: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    published_at: PropTypes.string,
    background_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
  className: PropTypes.string,
};

export default HighlightedArticle;
